import { Component, Input, ViewChild } from '@angular/core';
import { LoggerProvider, LoggerLevel, LoggerEvent } from '../../providers/logger/logger';

@Component({
  selector: 'rmt-error-message',
  templateUrl: 'rmt-error-message.html'
})
export class RmtErrorMessageComponent {
  @ViewChild('container') container;
  @Input() show: boolean = false;
  @Input() title: string;
  @Input() message: string;
  @Input() subtitle: string;
  @Input() showIcon: boolean = true;
  @Input() newDesign: boolean = false;
  @Input() imageSrc: string;

  constructor() {
  }

  ngOnChanges() {
    if (this.container) {
      let opacity = parseFloat(this.container.nativeElement.style.opacity);
      if (!opacity)
        opacity = 0.0;

      if (this.show && opacity < 1.0) {
        this.container.nativeElement.style.display = '';
        window.requestAnimationFrame(() => {
          this.container.nativeElement.style.opacity = 1.0;
        });
        this.logError({ title: this.title, message: this.message });
      }
      else if (!this.show && (opacity > 0.0 || !this.container.nativeElement.style.opacity)) {
        window.requestAnimationFrame(() => {
          this.container.nativeElement.style.opacity = 0.0;
        });
      }
    }
  }

  ngAfterViewInit() {
    this.container.nativeElement.addEventListener('webkitTransitionEnd', () => {
      if (!this.show && parseFloat(this.container.nativeElement.style.opacity) === 0.0) {
        this.container.nativeElement.style.display = 'none';
      }
    }, false);
  }

  logError(error) {
    LoggerProvider.log(this, LoggerLevel.Info, LoggerEvent.FormError, 'Form Input error', error)
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-error-message/rmt-error-message.ts